import { StyledEngineProvider } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import ScreenLoader from "components/ScreenLoader";
import CacheBuster from "react-cache-buster";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store, { persistor } from "redux/store";
import { PersistGate } from "redux-persist/integration/react";

import meta from "../meta.json";
import App from "./App";

const Root = () => (
  <CacheBuster
    currentVersion={meta.version}
    isEnabled={true} //If false, the library is disabled.
    isVerboseMode={false} //If true, the library writes verbose logs to console.
    //loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
    //metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
  >
    <Provider store={store}>
      <PersistGate loading={<ScreenLoader isScreenLoader />} persistor={persistor}>
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <App />
            </LocalizationProvider>
          </StyledEngineProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </CacheBuster>
);

export default Root;
